var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoodles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6001 17.8999C4.6001 21.109 5.87491 24.1867 8.1441 26.4559C10.4133 28.7251 13.491 29.9999 16.7001 29.9999C19.9092 29.9999 22.9869 28.7251 25.2561 26.4559C27.5253 24.1867 28.8001 21.109 28.8001 17.8999H4.6001Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1001 13.8002C7.2773 12.5071 7.91683 11.3219 8.90038 10.464C9.88392 9.606 11.1449 9.1333 12.4501 9.1333C13.7553 9.1333 15.0163 9.606 15.9998 10.464C16.9834 11.3219 17.6229 12.5071 17.8001 13.8002",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2998 8.49997C15.0258 7.67873 15.9188 7.02196 16.919 6.57358C17.9193 6.1252 19.0037 5.89554 20.0998 5.89997C21.1326 5.89988 22.1551 6.1049 23.108 6.50313C24.0609 6.90135 24.9253 7.48485 25.6509 8.21977C26.3765 8.9547 26.949 9.82641 27.335 10.7843C27.7211 11.7422 27.9131 12.7673 27.8998 13.8",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8999 10.9002C17.6801 10.2366 18.6759 9.88093 19.6999 9.90015C20.8497 9.89986 21.954 10.3497 22.7763 11.1533C23.5987 11.957 24.0738 13.0506 24.0999 14.2002",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8002 8.8L4.7002 3",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.8L4 8.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoodles);
export default __webpack_public_path__ + "static/media/noodles.52eab01a32862a3a7379865c360992f5.svg";
export { ForwardRef as ReactComponent };